export const SET_POSITIONS = "SET_POSITIONS";
export const SET_POSITION_ON_EDIT = "SET_POSITION_ON_EDIT";
export const UPDATE_POSITION = "UPDATE_POSITION";
export const DELETE_POSITION = "DELETE_POSITION";
export const ADD_POSITION = "ADD_POSITION";

export const setPositions = (positions) => ({
  type: SET_POSITIONS,
  payload: positions,
});

export const setPositionOnEdit = (positionOnEdit) => ({
  type: SET_POSITION_ON_EDIT,
  payload: positionOnEdit,
});

export const updatePosition = (updatedPosition) => ({
  type: UPDATE_POSITION,
  payload: updatedPosition,
});

export const removePosition = (positionId) => ({
  type: DELETE_POSITION,
  payload: positionId,
});

export const addPosition = (position) => ({
  type: ADD_POSITION,
  payload: position,
});
